import { uniqueKey } from 'global/common/keys'
import ModalOverlay from 'global/page/ModalOverlay'
import React from 'react'
import { Sidebar } from 'semantic-ui-react'

const Sidebarish = ({ contents, sidebarContent, visible, handleVisible, direction = 'left', sidebarClassName, isOverlay = true }) => {

  const modal = () => <ModalOverlay
    isOverlay={isOverlay}
    isSidebar={true}
    content={sidebarContent}
    closeOverlay={() => handleVisible(false)}
  />

  return (
    <Sidebar.Pushable style={{ overflow: 'hidden' }}>
      {visible && isOverlay && modal()}
      {!isOverlay && <Sidebar
        animation={'overlay'}
        direction={direction}
        onHide={() => handleVisible(false)}
        visible={visible}
        key={uniqueKey('ms', 'sb')}
        style={{ width: '90%' }}
        className={sidebarClassName ? sidebarClassName : null}
      >
        {visible && sidebarContent}
      </Sidebar>}
      <Sidebar.Pusher dimmed={visible ? true : false} className={'h100'}>
        {contents}
      </Sidebar.Pusher>
    </Sidebar.Pushable>
  )
}

export default Sidebarish
